// Used for purposes of mobile and tablet devices to set the max height to the innerHeight of the window.
export const appHeight = (): void => {
    const doc = document.documentElement
    doc.style.setProperty("--app-height", `${window.innerHeight}px`)
}
window.addEventListener("resize", appHeight)
window.addEventListener("orientationchange", appHeight)
appHeight()
